<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import storage from "./config/storage"
	import global from "./config/global"
	import { EventBus } from './config/eventBus';
	
	export default {
		
		data() {
			return {
				global: global,
			}
		},
		created() {
			console.log("App.vue loaded")
		
			// 获取上传图片token
			this.getUploadImgToken();
			// 获取信息
			this.getMyselfInfo();		
			
		},
		methods:{
			getMyselfInfo(){
				console.log("get employee myself info")
				
				const that = this;
				const token = storage.getToken();
				if (token && token.token){
					// 已登录状态					
					this.axios.get('/sys/employee/myself/info').then(function(response){
						let data = response.data;
						//console.log("get myself info:",data);
						if (data["code"] === 200){
							//保存用户信息
							that.global.employee = data["data"]["employee"];
							that.global.routeTree = data["data"]["menuTree"];
							
							// 判断当前的校区 是否有效
							const shopList = that.global.employee.shopList.length ? that.global.employee.shopList : that.global.employee.renewalShopList || [];
							
							//console.log("shop list:",shopList);
							if (shopList.length > 0){
								
								// 当前校区
								let currentShop =  storage.getCurrentShop();
								if (currentShop){
									// 是否有效
									let isValid = false;
									shopList.forEach((item,index)=>{
										if(item.id == currentShop.id){
											// 更新本地校区信息
											
											storage.setCurrentShop(item);
											isValid = true
											
											// 触发更新了shop事件
											EventBus.$emit("updateShop");
										}
									})
									
									if (!isValid){
										// 登录用户 已无当前校区的权限 需要处理
										storage.setCurrentShop(shopList[0]);
									}
									
								}else{
									// 把第一个设置为当前校区
									storage.setCurrentShop(shopList[0]);
									
								}
								
							}
							
							
							EventBus.$emit("updateShop");
							that.$router.push(storage.getRoute() || "/home/index");
							return
						}else if(data["code"] === 7031){
							console.log("token 已失效 需要重新登录")
							// 清除本地缓存 
							storage.clear();
							// 跳转到登录页
							that.$router.push("/login");
							return
						}else if(data["code"] === 7090){
							console.log("没有校区了")
							// 清除本地缓存 
							storage.clear();
							// 跳转到登录页
							that.$router.push("/login");
							return
						}
					});
				}else{
					this.$router.push("/login");
				}
			},
			getUploadImgToken(){
				console.log("getUploadImgToken from api")
				const that = this;
				// 获取上传图片的token保存到本地
				this.axios.get("/basic/qiniu/image/token").then(function(res) {
					if (res && res.data && res.data["code"] === 200 && res.data["data"]) {
						
						let qiniuToken = res.data["data"]["uploadToken"];
					
						storage.setUploadImgToken(qiniuToken);
					
						return
					}else{
						console.log("获取上传图片凭证失败");
					}
					
				});
			},
			
		}
	};
</script>
<style lang="scss">
	.tr_two{
		background: #eeeeee;
		
		&:hover td{
			background: #E1F5FE;
		}
	}
	.tr_one:hover td {
		background: #E1F5FE;
	}
</style>
